import { serverDriveFileRequestState } from '@/utils/serverInject'
import { saveSynoTokenToSessionStorage } from '@/utils/appinfo/synotoken'
import drivewebapi from './drivewebapi'
import { AUTH_STATUS } from '@/utils/constant'

// import toast from './toast'

const state = {
  sharingState: serverDriveFileRequestState(),
  authStatus: AUTH_STATUS.WAITING,
  previewFile: null,
  appData: {},
  appDataInited: false,
  routeLoading: true,
}
const mutations = {
  appData: (state, newAppData) => {
    state.appData = newAppData
    state.appDataInited = true
  },
  sharingState: (state, newSharingState) => {
    state.sharingState = newSharingState
  },
  routeLoading: (state, loading) => {
    state.routeLoading = loading
  },
  setAuthStatus: (state, status) => {
    state.authStatus = status
  },
  setPreviewFile: (state, file) => {
    state.previewFile = file
  }
}
const getters = {
  loggedIn: (state) => state.appData?.Session?.isLogined === true,
  loggedInUser: (state) => state.appData?.Session?.user,
  appLang: (state) => state.appData?.Session?.lang,
  isApplicationEnabled: (state) => (application) => state.appData?.packages?.some(
      (pkg) => pkg?.additional['dsm_apps']?.includes(application) && pkg?.additional?.status === 'running'),
  getAuthStatus: (state) => state.authStatus,
}

const actions = {
  async initAppData({ commit, state }) {
    if (state.appDataInited) {
      return
    }

    try {
      const resp = await drivewebapi.init()
      drivewebapi.setSynoToken(resp.Session.SynoToken)
      saveSynoTokenToSessionStorage(resp.Session.SynoToken)
      commit('appData', resp)
    } catch (err) {
      console.error('Failed to init app data', err)
    }
  },
  updateAuthStatus({ commit }, status) {
    commit('setAuthStatus', status)
  },
}

export { state, mutations, actions, getters }
